// libraries
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import done from "../../../assets/images/create-event/done/done.png";
import share from "../../../assets/images/details/share.svg";
import facebook from "../../../assets/images/details/facebook.svg";
import linkedin from "../../../assets/images/details/linkedin.svg";
import twitter from "../../../assets/images/details/twitter.svg";
import email from "../../../assets/images/details/email.svg";
import whatsapp from "../../../assets/images/details/whatsapp.svg";
import phone from "../../../assets/images/details/phone.svg";

// utils
import { convertToSlug } from "src/utils/helpers";

// animation
import FadeTop from "src/components/Animation/FadeTop";

const Content = ({ data }) => {
  const [eventData, setEventData] = useState(null);
  const [url, setUrl] = useState("");
  const [slug, setSlug] = useState("");

  useEffect(() => {
    if (data) {
      setEventData(data);

      let origin = window.location.origin;
      let slug = convertToSlug(data?.eventName);
      setSlug(slug);

      let link = `${origin}/${slug}/${data?.eventId}/${data?.timeId}`;
      setUrl(link);
    }
  }, [data]);

  const trimText = (_str, _length) => {
    if (!_str) return "";
    return _str.substring(0, _length);
  };

  console.log(url);

  return (
    <div className={styles.done}>
      <FadeTop duration={0.5} y={80}>
        <img src={done} alt="done" className={styles.main_img} />
      </FadeTop>
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        Your event was successfully added!
      </motion.h1>
      <motion.h3
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut", delay: 0.1 }}
      >
        Now let’s get it out to your friends
      </motion.h3>
      <motion.h5
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
      >
        <img src={share} alt="share" />
        Share with Friends
      </motion.h5>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut", delay: 0.1 }}
      >
        <div className={styles.social}>
          <img src={facebook} alt="facebook" className={styles.facebook} />
          <img src={linkedin} alt="linkedin" className={styles.linkedin} />
          <img src={twitter} alt="twitter" className={styles.twitter} />
          <img src={email} alt="email" className={styles.email} />
          <img src={whatsapp} alt="whatsapp" className={styles.whatsapp} />
          <img src={phone} alt="phone" className={styles.phone} />
        </div>
      </motion.div>
      {/* <h6>eventmoon/{trimText(convertToSlug(eventData?.eventName), 10)}</h6> */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut", delay: 0.1 }}
        className={styles.copy_link}
      >
        <span>eventmoon/{trimText(slug, 10)}</span>
        <span
          onClick={() => {
            navigator.clipboard.writeText(url);
            toast.success("url copied", {
              className: "bg-blue",
              position: "bottom-center",
            });
          }}
        >
          Copy Link
        </span>
      </motion.div>
      <div className={styles.btns}>
        <Link to="/">
          <motion.button
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            Back to Home
          </motion.button>
        </Link>
        <Link to={`/${slug}/${eventData?.eventId}/${eventData?.timeId}`}>
          <motion.button
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={styles.right}
          >
            View event
          </motion.button>
        </Link>
      </div>
    </div>
  );
};

export default Content;
